import type { LocationQuery } from '#vue-router'
import type { PharmacyDetails } from '~/models/pharmacy-details'

export const navigateToPharmacyPage = (pharmacyDetails: PharmacyDetails, query?: Record<string, string> | LocationQuery, subPath?: string) => {
  const { getPharmacyRoute } = useRouteUtils()
  const pharmacyUrl = getPharmacyRoute(pharmacyDetails).href

  return customNavigateTo({
    path: `${pharmacyUrl}${subPath ?? ''}`,
    query: query || {},
  })
}
